// DSC37-F1 (docs/build-briefs/DSC37-F1-red-discount-save-error.md). The reading of a refused Settings
// discount save. Owner standing directive (Kerry, 2026-10-09, TEN21): a missed or refused field "needs to
// stand out in bright red". The server's refusals for a discount save all carry the generic code
// `invalid_request`, so no code names a field; the control at fault is the one the save started from, which
// the caller knows. The server's sentence is shown as written (first letter capitalized, nothing added).
// Pure and DOM-free so a plain node:test file can import it.

import { capitalizeServerMessage } from "./serverMessageDisplay.ts";

/** Which Settings save was refused. */
export type DiscountSaveAttempt = "add" | "flag" | "markdown" | "rename" | "scope";

/** Shown when the server sends no sentence, so the red line is never blank. */
export const DISCOUNT_SAVE_REFUSAL_FALLBACK = "Check your connection.";

export interface DiscountSaveRefusal {
  /** The sentence shown in red. */
  readonly text: string;
  /** `sheet`: the Add Discount popout's error line. `control`: beside the row control the save started from. */
  readonly place: "sheet" | "control";
}

export function discountSaveRefusal(
  attempt: DiscountSaveAttempt,
  serverMessage: string | undefined,
): DiscountSaveRefusal {
  const message =
    serverMessage !== undefined && serverMessage.trim() !== ""
      ? serverMessage
      : DISCOUNT_SAVE_REFUSAL_FALLBACK;
  return { text: capitalizeServerMessage(message), place: attempt === "add" ? "sheet" : "control" };
}
